var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._g({attrs:{"icon":""},on:{"click":function($event){return _vm.emitClick()}}},_vm.eventHandlers),[_c('v-icon',{attrs:{"color":"accent"}},[_vm._v(" "+_vm._s(_vm.icon)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }